import { ButtonBase, Stack, SxProps } from "@mui/material";
import { PropsWithChildren, ReactNode } from "react";

export const TypeButton = ({
  icon,
  onClick,
  selected,
  children,
  sx,
  disabled = false,
}: PropsWithChildren<{
  icon: ReactNode;
  onClick: () => void;
  selected?: boolean;
  sx?: SxProps;
  disabled?: boolean;
}>) => {
  return (
    <ButtonBase
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
      disabled={disabled}
      sx={{
        width: "336px",
        maxWidth: "100%",
        height: "200px",
        border: "1px solid #a8a8a8",
        borderRadius: "16px",
        opacity: disabled && !selected ? 0.6 : 1,
        cursor: disabled && !selected ? "not-allowed" : "pointer",
        ...sx,
      }}
    >
      <Stack
        alignContent={"center"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        {icon}
        {children}
      </Stack>
    </ButtonBase>
  );
};
